import { render, staticRenderFns } from "./planUpload.vue?vue&type=template&id=220a2848"
import script from "./planUpload.vue?vue&type=script&lang=js"
export * from "./planUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports